module.exports = __webpack_public_path__ + "static/img/chainhoverbg.9b88306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/chainhoverbg.png
// module id = lTkl
// module chunks = 44